import { UserAvatar } from "./UserAvatar";
import { VerticalDotsIcon } from "./Svg";
import { DropdownMenu, DropdownMenuItem } from "./DropdownMenu";
import { getUserFullName } from "../store/models/User";
import { UserRoleLabels, UserRoleColors } from "../constants";
import React from "react";
import cx from "classnames";

const getTimeAgo = (timestamp) => {
  const now = Date.now();
  const ts = parseInt(timestamp);
  const diffMs = now - ts;
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffYears > 0) {
    return `Invited ${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
  } else if (diffMonths > 0) {
    return `Invited ${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
  } else if (diffWeeks > 0) {
    return `Invited ${diffWeeks} week${diffWeeks > 1 ? 's' : ''} ago`;
  } else if (diffDays > 0) {
    return `Invited ${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  } else if (diffHours > 0) {
    return `Invited ${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  } else if (diffMinutes > 0) {
    return `Invited ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''} ago`;
  } else {
    return 'Invited just now';
  }
};

export const PendingInviteItem = ({ invite, currentUser, onResend, onCancel, canManage = null }) => {
  const isAdmin = currentUser?.role === "admin";
  const canManageInvites = canManage !== null ? canManage : isAdmin;
  const userName = getUserFullName(invite);
  const isExpired = invite.expired;
  const timeAgo = getTimeAgo(invite.ts);

  const handleResend = () => {
    if (onResend) {
      onResend(invite);
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel(invite);
    }
  };

  return (
    <div className={cx("MemberItem", { "MemberItem--expired": isExpired })}>
      <div className={"MemberItem__Left"}>
        <div className={"MemberItem__Avatar"} style={{ marginLeft: '2rem' }}>
          <UserAvatar user={invite} />
        </div>
        <div className={"MemberItem__Info"}>
          {userName && <div className={"MemberItem__Name"}>{userName}</div>}
          <div className={"MemberItem__Email"}>{invite.email}</div>
          <div className={"MemberItem__PendingLabel"}>{timeAgo}</div>
          {invite.role && (
            <div className={"MemberItem__RoleBadge"} style={{ backgroundColor: UserRoleColors[invite.role] }}>
              {UserRoleLabels[invite.role]}
            </div>
          )}
        </div>
        {canManageInvites && (
          <div className={"MemberItem__Right"}>
            <DropdownMenu icon={<VerticalDotsIcon />}>
              <DropdownMenuItem
                label={"Resend invite"}
                onClick={handleResend}
              />
              <DropdownMenuItem
                label={"Cancel invite"}
                onClick={handleCancel}
              />
            </DropdownMenu>
          </div>
        )}
      </div>
    </div>
  );
};

export const PendingInviteItemsList = ({ invites, currentUser, onResend, onCancel, canManage = null }) => {
  return (
    <div className={"MemberItemsList"}>
      {invites.map((invite, index) => (
        <PendingInviteItem
          key={invite.ts || `${invite.email}-${index}`}
          invite={invite}
          currentUser={currentUser}
          onResend={onResend}
          onCancel={onCancel}
          canManage={canManage}
        />
      ))}
    </div>
  );
};

